import React from "react";
import trans from "../../../../utils";

export default function POIsPositionsHeadPopups({ data }) {
  return (
    <div className="device-popup-head">
      <div className="device-popup-name">{data?.name}</div>
      <div className="device-popup-status" dir="ltr">
        {data?.geofenced && (
          <img
            src={`${process.env.PUBLIC_URL}/assets/dark/Geofence.svg`}
            alt="status"
          />
        )}
        <div className="ms-1">{trans("Geofenced")}</div>
      </div>
    </div>
  );
}
